import React from "react";

export default function Logo(): React.JSX.Element {
  return <i className="icon-scd-password-invisible" />;
}
